import React from "react";
import Card from "components/card";
import dayjs from "dayjs";
import { SubscriptionInfo } from "api/usage";
import { useTranslation } from "react-i18next";

interface SubscriptionInfoCardProps {
  subscriptionInfo: SubscriptionInfo;
}

const SubscriptionInfoCard: React.FC<SubscriptionInfoCardProps> = ({
  subscriptionInfo,
}) => {
  const { t } = useTranslation();

  const formatFrequency = (frequency: string) => {
    const key = `usageOverview.subscriptionInfo.frequency.${frequency}`;
    const translated = t(key, { defaultValue: frequency });
    return translated;
  };

  const priceLabel = t("usageOverview.subscriptionInfo.price", {
    price: subscriptionInfo.price,
    frequency: formatFrequency(subscriptionInfo.frequency),
  });

  return (
    <Card extra="p-6">
      <div className="mb-4">
        <h3 className="mb-4 text-lg font-semibold text-navy-700 dark:text-white">
          {t("usageOverview.subscriptionInfo.title")}
        </h3>
      </div>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="mb-3 flex items-center gap-3">
            <h4 className="text-xl font-bold text-navy-700 dark:text-white">
              {subscriptionInfo.name}
            </h4>
            <span className="text-sm text-gray-500 dark:text-gray-400">
              {t("usageOverview.subscriptionInfo.current")}
            </span>
            <span className="text-sm text-gray-500 dark:text-gray-400">
              {priceLabel}
            </span>
          </div>
          {(subscriptionInfo.startDate || subscriptionInfo.endDate) && (
            <div className="mt-2 space-y-1 text-sm text-gray-600 dark:text-gray-400">
              {subscriptionInfo.startDate && (
                <div>
                  <span className="font-medium">
                    {t("usageOverview.subscriptionInfo.startDate")}:{" "}
                  </span>
                  {dayjs(subscriptionInfo.startDate).format("MMM DD, YYYY")}
                </div>
              )}
              {subscriptionInfo.endDate && (
                <div>
                  <span className="font-medium">
                    {t("usageOverview.subscriptionInfo.endDate")}:{" "}
                  </span>
                  {dayjs(subscriptionInfo.endDate).format("MMM DD, YYYY")}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

export default SubscriptionInfoCard;
